import Constants from '../../common/constants';

const imageFolder = `${Constants.IMAGE_FOLDER}depionier/`;

const title = "Holy Road - De Pioneer";
const description = "The Jewish outpost Amona was built on the land of Palestinian farmers. The Palestinians initiated a lawsuit and won, thanks to a Jewish Israeli activist.";
const featuredImage = `${imageFolder}depionier/omslag.jpg`;

export default [
    {
        type: "Meta",
        title: title,
        meta: [
            {"property": "og:title", "content": title},
            {"property": "og:url", "content": `${Constants.DOMAIN}${Constants.STORY_URL}depionier`},
            {"property": "description", "content": ""},
            {"property": "og:description", "content": description},
            {"property": "og:image", "content": featuredImage},
            {"property": "twitter:card", "content": `summary_large_image`},
            {"property": "twitter:title", "content": title},
            {"property": "twitter:description", "content": description},
            {"property": "twitter:image", "content": featuredImage},
        ]
    },
    {
        type: "Quote",
        quote: description,
    },
    {
        type: "Iframe",
        hideSpacer: true,
        url: "https://player.vimeo.com/video/248453349"
    },
    {
        type: "Paragraph",
        text: "Eli Greenberg lived on a hill in the West Bank. All right, maybe the land on which his house was built legally belonged to a Palestinian, but why would that matter? The most important thing, according to Greenberg, is that three thousand years ago God promised this land to the Jews. There is no law that could change that."
    },
    {
        type: "Paragraph",
        text: "According to international law Israel is occupying the West Bank. However, an increasing number of Jewish settlers do not care about this. They do not listen to the legislator, but only to God. For that reason, some of them even turn their backs on the state of Israel altogether, as they believe that Israel should be a theocracy, with the Torah as its constitution."
    },
    {
        type: "Paragraph",
        text: "The Palestinians of the West Bank consider themselves the native inhabitants of this land and feel threatened by foreign Jewish settlers who make their lives miserable. Likewise, the settlers claim to be the native inhabitants, indicating they were already living there thousands of years ago."
    },
    {
        type: "Paragraph",
        text: "Secular Israelis do not identify with their fanatic compatriots. However, unwillingly they have to witness how extremists gain more and more influence on the Israeli government policy. Some leftist activists have booked small successes at the Israeli Supreme Court, which is how settler Greenberg lost his land, for example."
    },
    {
        type: "Paragraph",
        text: "Nevertheless, the future of the peace movement looks dark. The entire scope of Israeli politics is shifting to the right, and with them their electorate. It has become commonplace in Israel to claim that ‘all Arabs are terrorists’, or that they were born to hate Jews. The peace activists are being demonized themselves within Israeli society."
    }
]


// WEBPACK FOOTER //
// ./src/data/stories/story6.js